var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOurBlueVet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0069b1",
    d: "M21.9 30.5h3.8v-4.75h4.75v-3.8H25.7V17.2h-3.8v4.75h-4.75v3.8h4.75Zm1.9 13.252q-6.65-1.662-10.925-7.718T8.6 22.758V11.452l15.2-5.7 15.2 5.7v11.306q0 7.22-4.275 13.276T23.8 43.752Zm0-18.43Zm0 15.485q5.462-1.805 8.906-6.816 3.444-5.011 3.444-11.233v-9.31L23.8 8.793l-12.35 4.655v9.31q0 6.222 3.444 11.233 3.443 5.011 8.906 6.816Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurBlueVet);
export default __webpack_public_path__ + "static/media/OurBlueVet.38e95550e47949be3e23fdbcb5b9e01c.svg";
export { ForwardRef as ReactComponent };